import { computed, defineComponent, reactive, ref, watch } from "vue";
import aiDialog from "@/components/AiDialog";
import { checkPayApi, createOrderApi, getVipList } from "@/service/canvas";
import { ElMessage } from "element-plus";
import qrcode from "qrcode";
import couponDialog from "@/components/CouponDialog";
import dayjs from "dayjs";
import { useStore } from "vuex";
import { CountUp } from "countup.js";
export default defineComponent({
  name: "VipDialog",
  components: {
    aiDialog,
    couponDialog
  },
  setup(props, {
    attrs
  }) {
    // 枚举
    const VIP_TYPE = {
      0: "normal",
      1: "pro",
      normal: 0,
      pro: 1
    };
    // 当前选中的vip类型
    const vipType = ref(0);
    // vip数据集合
    const vipTypeObj = reactive({
      [VIP_TYPE[VIP_TYPE.normal]]: {
        name: "普通会员",
        value: 0,
        desc: "3.5模型无限使用",
        list: [],
        active: 0,
        tip: "当前会员不含绘画次数，如需使用AI绘画功能，请购买“Pro会员”",
        vipItem: [{
          name: "不限次数",
          icon: "no-times"
        }, {
          name: "极速响应",
          icon: "fast"
        }, {
          name: "智能问答",
          icon: "chat"
        }, {
          name: "功能解锁",
          icon: "unlock"
        }]
      },
      [VIP_TYPE[VIP_TYPE.pro]]: {
        name: "PRO会员",
        value: 1,
        desc: "4.0模型+mj绘画无限使用",
        list: [],
        active: 0,
        tip: `购买"Pro会员"享受无限次数AI绘画`,
        vipItem: [{
          name: "双重权益",
          icon: "double"
        }, {
          name: "Ai绘画",
          icon: "draw"
        }, {
          name: "无限对话",
          icon: "no-limit"
        }, {
          name: "智能问答",
          icon: "chat"
        }]
      }
    });
    const vipList = ref([]);
    let checkOrderTimer = -1;
    const order_id = ref("");
    const pay_url = ref("");

    // 选中的vip
    const vip_id = computed(() => {
      return vipTypeObj[VIP_TYPE[vipType.value]].active.id;
    });
    watch(vip_id, () => {
      if (attrs.modelValue) {
        createOrder();
      }
    });

    // 是否用了卡券
    let useCoupon = ref(false);
    const showCouponDialog = ref(false);
    const qrcodeImg = ref("");

    // 用来做数字动画的ref
    const price0 = ref(null);
    const price1 = ref(null);

    // 需要支付的金额
    const payPrice = computed(() => {
      const pay = vipList.value.find(item => item.id === vip_id.value);
      return useCoupon.value && pay.num >= 12 ? pay.price - 100 : pay.price;
    });
    const store = useStore();
    const isSVip = computed(() => {
      return store.getters.isSVip;
    });

    // 是否同意协议
    const agreement = ref(true);
    const payTimeOut = ref(600);
    let payTimer = null;
    function startTimer() {
      clearInterval(payTimer);
      payTimeOut.value = 600;
      payTimer = setInterval(() => {
        payTimeOut.value -= 1;
      }, 1000);
    }
    watch(pay_url, async v => {
      if (v) {
        qrcodeImg.value = await qrcode.toDataURL(v);
      }
    }, {
      immediate: true
    });
    function opened() {
      if (!isSVip.value) {
        showCouponDialog.value = true;
      }
      createOrder();
    }
    getVipList().then(res => {
      if (!res.errno) {
        vipList.value = res.data.map(item => {
          return {
            ...item,
            price: item.price / 100
          };
        });

        // 普通会员
        vipTypeObj.normal.list = vipList.value.filter(item => item.banben === 0);
        vipTypeObj.normal.active = vipTypeObj.normal.list.find(item => item.num >= 12);
        // 高级会员
        vipTypeObj.pro.list = vipList.value.filter(item => item.banben === 1);
        vipTypeObj.pro.active = vipTypeObj.pro.list.find(item => item.num >= 12);
      }
    });
    function checkPay() {
      checkPayApi({
        order_id: order_id.value
      }).then(res => {
        if (res.data.ispay) {
          ElMessage.success("付款成功");
          checkOrderTimer = null;
          window.location.reload();
        }
      });
    }

    // 创建订单
    function createOrder() {
      createOrderApi({
        vip_id: vip_id.value,
        youhui_id: useCoupon.value ? 1 : ""
      }).then(res => {
        order_id.value = res.data.order_id;
        pay_url.value = res.data.pay_url;
        startTimer();
        clearInterval(checkOrderTimer);
        checkOrderTimer = setInterval(() => {
          checkPay();
        }, 3000);
      });
    }
    return {
      VIP_TYPE,
      vipTypeObj,
      vipType,
      vipList,
      pay_url,
      qrcodeImg,
      agreement,
      vip_id,
      payPrice,
      useCoupon,
      showCouponDialog,
      payTimeOut,
      price1,
      price0,
      checkPay,
      opened,
      closed(done) {
        clearInterval(checkOrderTimer);
        clearInterval(payTimer);
        const nums = [price1.value, price0.value];
        nums.forEach(item => {
          if (item[0]) {
            item[0].innerText = +item[0].getAttribute("data-price");
          }
        });
        useCoupon.value = false;
        done();
      },
      toTime(time) {
        let m = parseInt(time / 60 % 60);
        m = m < 10 ? "0" + m : m;
        let s = parseInt(time % 60);
        s = s < 10 ? "0" + s : s;
        // 作为返回值返回
        return `${m}:${s}`;
      },
      dayjs,
      chooseVip(type, vip) {
        vipTypeObj[VIP_TYPE[type]].active = vip;
        // createOrder();
      },

      selectedCoupon() {
        useCoupon.value = true;
        showCouponDialog.value = false;
        clearInterval(checkOrderTimer);
        clearInterval(payTimer);
        // 选择优惠券后，重新创建订单
        createOrder();
        const nums = [price1.value, price0.value];
        nums.forEach(item => {
          if (item) {
            const _item = item[0];
            const text = +_item.getAttribute("data-price");
            const numAnim = new CountUp(_item, text - 100, {
              duration: 3.0,
              startVal: text
            });
            numAnim.start();
          }
        });
      }
    };
  }
});